export class Address {
  public suburbCd: string;
  public addressDescr: string;
  public addrLine1: string;
  public addrLine2: string;
  public addrLine3: string;
  public addrLine4: string;
  public suburb: string;
  public cityCd: string;
  public city: string;
  public countryId: string;
  public countryDescr: string;
  public regionCd: string;
  public region: string;
  public postalCode: string;
  public plotFarmShInd: string;
}
